module.exports = __webpack_public_path__ + "img/Bussines.9e4b1c95.png";